'use client';

import { Trans } from '@lingui/macro';
// import DeleteOutline from '@mui/icons-material/DeleteOutline';
import { List, ListItem, ListItemText, Stack, Typography } from '@mui/material';
// import IconButton from '@mui/material/IconButton';
import { useRouter } from '@prismo-io/router';
import type { FC } from 'react';
import { useSWRConfig } from 'swr';
import { useAppetencesSidebar } from '../../../hooks/use-appetences-sidebar';
import { useDeleteSkill } from '../../../hooks/use-delete-skill';
import type { AppetenceT, AppetencesT } from '../../../utils/fetch-appetences';
import { SkeletonItems } from '../skeleton-item';
export const SidebarAppetenceList: FC = () => {
  const {
    data,
    isLoading
  } = useAppetencesSidebar();
  const router = useRouter();
  const {
    mutate
  } = useSWRConfig();
  const sortList: AppetencesT = data ? data : [];
  const {
    trigger: deleteSkill
  } = useDeleteSkill();
  const onDeleteItem = (appetence: AppetenceT) => {
    console.log(`delete appetence ${appetence.code}`);
    // deleteSkill(
    //   {
    //     id: skill.id,
    //     type: skill.type,
    //   },
    //   {
    //     onSuccess: async () => {
    //       router.refresh();
    //       mutate('appetences-quark-sidebar');
    //     },
    //   }
    // );
  };
  return <>
      <Stack direction="row" alignItems="center" gap={1} padding={2} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
        <Typography variant="h1" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Mes Appétences</Trans> {!isLoading && `(${sortList.length})`}
        </Typography>
      </Stack>
      <List data-sentry-element="List" data-sentry-source-file="index.tsx">
        {isLoading && <SkeletonItems />}
        {sortList.length > 0 && sortList.map(appetence => {
        return <ListItem key={appetence.code}
        // secondaryAction={
        //   <IconButton
        //     edge="end"
        //     aria-label="delete"
        //     onClick={() => onDeleteItem(appetence)}
        //   >
        //     <DeleteOutline />
        //   </IconButton>
        // }
        >
                <ListItemText primary={appetence.name} sx={{
            '& .MuiListItemText-primary': {
              display: 'flex',
              gap: 1,
              fontWeight: 700,
              '&::before': {
                content: '"-"'
              }
            }
          }} />
              </ListItem>;
      })}
      </List>
    </>;
};